import { CareerType, ResumeTabsType } from '../../../../../types/ResumeTypes';

import C from '../ViewerMode.module.scss';
import ResumeInfoPeriod from '../../../../common/ResumeInfoPeriod/index';
import { DateTimeUtils } from '../../../../../utils/DateTimeUtils';
import { ConstantUtils } from '../../../../../utils/ConstantUtils';
import dayjs from 'dayjs';

interface CareerViewerProps {
  careers: CareerType[];
  resumeTabs: ResumeTabsType;
}

const CareerViewer = (props: CareerViewerProps) => {
  const { careers, resumeTabs } = props;

  if (careers === undefined || careers.length === 0) {
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[2].element} className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>경력사항</h4>
        {careers?.map((career, index) => {
          return <CareerElementViewer career={career} key={`career-viewer-${index}`} />;
        })}
      </section>
      <hr />
    </>
  );
};

interface CareerElementViewerProps {
  career: CareerType;
}

const CareerElementViewer = (props: CareerElementViewerProps) => {
  const { career } = props;
  return (
    <>
      {/* 개별 박스 */}
      <article className={`${C.common_box}`}>
        {/* 기간 */}
        {
          <ResumeInfoPeriod
            text={DateTimeUtils.calculateBetweenCareerDate(
              career.startAt,
              career.endAt || DateTimeUtils.toDateStringYYYYMM(new Date()),
            )}
            startDate={career.startAt}
            endDate={career.endAt || DateTimeUtils.toDateStringYYYYMM(new Date())}
          />
        }

        {/* 상세 내용 */}
        <div className={`${C.profile_text_wrap}`}>
          <div className={`${C.profile_text_line}`}>
            <div className={C.text_el_wrap}>
              <h2 className="h2">{career.name || ''}</h2>
              <span className="divided-line" />
              <h4 className="h4">{career.position || ''}</h4>
              <span className="divided-line" />
              <h4 className="h4">{ConstantUtils.convertToEmployment(career.employmentType)}</h4>
            </div>
          </div>
          <div className={C.profile_text_line}>
            <div className={C.text_el_wrap}>
              <h4 className="b1">{career.description || ''}</h4>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default CareerViewer;
